import React, { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

const ThemeToggle = ({ className = "", mobile = false }) => {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const isDark = mounted && resolvedTheme === "dark";

  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className={`theme-toggle ${mobile ? "theme-toggle-mobile" : ""} ${className}`.trim()}
      aria-label={mounted ? `Switch to ${isDark ? "light" : "dark"} mode` : "Toggle color mode"}
      data-testid={mobile ? "mobile-theme-toggle" : "theme-toggle"}
    >
      <span className="theme-toggle-track" aria-hidden="true">
        <Sun className={`h-4 w-4 transition-all duration-300 ${isDark ? "opacity-40" : "opacity-100"}`} strokeWidth={2} />
        <Moon className={`h-4 w-4 transition-all duration-300 ${isDark ? "opacity-100" : "opacity-40"}`} strokeWidth={2} />
      </span>
      <span className="theme-toggle-label">{isDark ? "Dark" : "Light"}</span>
    </button>
  );
};

export default ThemeToggle;
